/* FOLIVEX PDP — single-variant + quantity-discount bundle picker
   Vulcan pattern: all bundle cards share the same data-vid; differentiator is data-qty.
   Reads data-qty (NOT radio value) for cart line item quantity. */
(function () {
  'use strict';
  const root = document.getElementById('fx-pdp');
  if (!root) return;

  const form  = root.querySelector('#fx-form');
  const atc   = root.querySelector('#fx-atc');
  const atcLabel = root.querySelector('.fx-buy__atc-label');
  const atcPrice = root.querySelector('.fx-buy__atc-price');
  const cards = root.querySelectorAll('.fx-bundle');

  function fmt(n) { return '$' + Number(n).toFixed(2); }
  function selectedCard() {
    for (const c of cards) {
      const input = c.querySelector('input[name="fx-bundle-pick"]');
      if (input && input.checked) return c;
    }
    return null;
  }
  function refreshAtcLabel() {
    const c = selectedCard();
    if (!c) return;
    const now = c.dataset.now || '48.00';
    const lbl = c.dataset.label || 'Bundle';
    if (atcLabel) atcLabel.textContent = 'ADD TO CART — ' + lbl;
    if (atcPrice) atcPrice.textContent = '| ' + fmt(now);
  }
  cards.forEach(c => {
    c.addEventListener('click', () => {
      const input = c.querySelector('input[name="fx-bundle-pick"]');
      if (input && !input.checked) { input.checked = true; refreshAtcLabel(); }
    });
    const input = c.querySelector('input[name="fx-bundle-pick"]');
    if (input) input.addEventListener('change', refreshAtcLabel);
  });
  refreshAtcLabel();

  /* Cart permalink — single navigation, server adds line + redirects to checkout flow.
     Per Vulcan playbook: prefer permalink over fetch+redirect for buy-now funnels.
     We use /cart (NOT /checkout) so customers see the discount + free-shipping land. */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const c = selectedCard();
    if (!c) return;
    const vid = c.dataset.vid;
    const qty = c.dataset.qty || '1';
    if (atcLabel) atcLabel.textContent = 'ADDING TO CART…';
    window.location.href = '/cart/' + vid + ':' + qty;
  });
})();
